import { jsx as t, jsxs as h } from "react/jsx-runtime";
import "react";
var e = (i) => /* @__PURE__ */ h("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...i,
  children: [
    /* @__PURE__ */ t("rect", {
      width: 20,
      height: 20,
      fill: "#F5F5F5"
    }),
    /* @__PURE__ */ t("rect", {
      width: 1876,
      height: 988,
      transform: "translate(-588 -692)",
      fill: "white"
    }),
    /* @__PURE__ */ t("path", {
      d: "M19.9993 0.000610352H0.0859375V19.9999H19.9993V0.000610352Z",
      fill: "#751A46"
    }),
    /* @__PURE__ */ t("path", {
      d: "M8.18182 4.0545L6.21948 5.54139L8.18182 7.02769L6.21948 8.51458L8.18182 10.0009L6.21948 11.4878L8.18182 12.974L6.21948 14.461L8.18182 15.9473L6.21948 17.4342L8.18182 18.9211L6.758 19.9998H0V0H6.75542L8.18182 1.08064L6.21948 2.56761L8.18182 4.0545Z",
      fill: "#F0F0F0"
    })
  ]
});
export {
  e as default
};
